import React from 'react';
import GavelIcon from '@mui/icons-material/Gavel';
import { Box, Typography } from '@mui/material';
import LegalLayout, { Section, P, Ul } from './LegalLayout';

export default function TermsConditions() {
  return (
    <LegalLayout
      title="Terms & Conditions"
      updated="Effective: 25 July 2026 · Home Billing POS software & owner portal"
      icon={GavelIcon}
    >
      <Section title="1. Agreement to terms">
        <P>
          By accessing or using the Home Billing POS owner portal (homebillingpos.com), desktop counter
          software, or companion mobile apps, you agree to these Terms. If you act for a business, you
          confirm you have authority to bind that business.
        </P>
      </Section>

      <Section title="2. License grant & software use">
        <P>
          We grant you a non-exclusive, non-transferable, revocable license to install and run Home Billing
          POS for your restaurant operations (orders, billing, kitchen, inventory, and related staff use).
        </P>
        <Ul
          items={[
            <><strong>Device limits:</strong> Counter PC activation is subject to your plan (typically one counter PC per branch, as described in the portal). Mobile devices on the same branch LAN are included for staff use under your subscription rules.</>,
            <><strong>Restrictions:</strong> You may not reverse engineer, resell, sub-license, or redistribute the software, license keys, or embedded services except as we expressly allow.</>,
          ]}
        />
      </Section>

      <Section title="3. Account responsibilities">
        <P>
          You must keep owner-portal credentials and staff access methods confidential. You are responsible
          for activity under your account, including menu prices, staff access, and financial settlements
          recorded in the system.
        </P>
      </Section>

      <Section title="4. Subscription fees & payments">
        <P>
          Pricing is shown in the owner portal (including trial and per-branch annual fees). Additional
          branch purchases may be processed through PayU or other payment providers we designate.
          Renewals and branch add-ons must be paid to keep related cloud features and entitlements active.
        </P>
      </Section>

      <Section title="5. Service availability & offline use">
        <P>
          The product is designed for offline counter operation with local LAN sync. Cloud portal access,
          license checks that require the internet, and remote features need connectivity. We do not
          guarantee uninterrupted cloud availability.
        </P>
      </Section>

      <Section title="6. Limitation of liability">
        <P>
          To the maximum extent permitted by law, Home Billing POS and its affiliates are not liable for
          indirect, incidental, or consequential damages, lost profits, or data loss arising from hardware
          failure, power loss, network misconfiguration, or misuse of the software.
        </P>
      </Section>

      <Box>
        <Typography variant="h6" fontWeight={700} gutterBottom color="primary.main">
          7. Governing law & contact
        </Typography>
        <P>
          These Terms are governed by the laws of India. For legal questions: support@homebillingpos.com
          (subject line: Legal / Terms).
        </P>
      </Box>
    </LegalLayout>
  );
}
